module.exports = __webpack_public_path__ + "static/media/great_aunt_millie.b3f9e1cd.svg";